import request from '@/config/axios'

export interface WalletRechargeVO {
  id: number
  walletId: number
  userId?: number
  userType?: number
  totalPrice: number
  payPrice: number
  bonusPrice: number
  packageId?: number
  packageName?: string
  payStatus: boolean
  payOrderId?: number
  tradeOrderId?: number
  payChannelCode?: string
  payChannelName?: string
  payOrderChannelOrderNo?: string
  payTime?: Date
  refundStatus?: number
  refundTotalPrice?: number
  refundPayPrice?: number
  refundBonusPrice?: number
  refundTime?: Date
  payRefundId?: number
  createTime?: Date
}

/** 管理端：钱包充值记录分页 */
export const getWalletRechargePage = async (params) => {
  return await request.get({ url: '/pay/wallet-recharge/page', params })
}

/** 发起钱包充值退款 */
export const refundWalletRecharge = async (id: number) => {
  return await request.post({ url: '/pay/wallet-recharge/refund', params: { id } })
}
